import React from "react";
import {
  FaTimes,
  FaExclamationTriangle,
  FaCheck,
  FaTrashAlt,
} from "react-icons/fa";
import { Modal, Backdrop, Fade, Box } from "@mui/material";

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Onayla",
  cancelText = "İptal",
  isLoading = false,
  // Mesajın altında gösterilecek opsiyonel ek içerik (ör. seçenek checkbox'ı)
  children = null,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 450,
    bgcolor: "background.paper",
    borderRadius: "16px",
    boxShadow: 24,
    p: 0,
    outline: "none",
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
          style: {
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(5px)",
          },
        },
      }}
      style={{ zIndex: 10002 }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <div className="bg-white rounded-2xl overflow-hidden">
            <div className="p-5 text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaExclamationTriangle className="w-8 h-8 text-red-500" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
              <p className="text-gray-600 mt-2">{message}</p>
              {children && <div className="mt-4 text-left">{children}</div>}
            </div>

            <div className="px-5 py-4 bg-gray-50 border-t flex items-center justify-center gap-4">
              <button
                type="button"
                onClick={onClose}
                disabled={isLoading}
                className="w-full px-4 py-3 bg-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-300 transition-colors disabled:opacity-50"
              >
                <FaTimes className="inline mr-2" />
                {cancelText}
              </button>
              <button
                type="button"
                onClick={onConfirm}
                disabled={isLoading}
                className="w-full flex justify-center items-center px-4 py-3 bg-red-600 text-white rounded-xl font-semibold transition-all shadow-md hover:bg-red-700 disabled:bg-red-300"
              >
                {isLoading ? (
                  "İşleniyor..."
                ) : (
                  <>
                    <FaTrashAlt className="inline mr-2" />
                    {confirmText}
                  </>
                )}
              </button>
            </div>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ConfirmationModal;
